const UploadStatus = {
    "Failed": 0,
    "Success": 1,
    "Partially Uploaded": 2
};

export default UploadStatus;